import api from './api';

export async function getEmpresasByEmail(email) {
    const ret = await api.get('/auth/getempresasbyemail', { params: { email }, noLoading: true });
    return ret.data;
}

export async function login(email, senha, remember, cdempresa) {
    const ret = await api.post(`/auth/login`, { email, senha, remember, cdempresa });
    return ret.data;
}

export async function loginWithGoogle(googleToken, cdempresa) {
    const ret = await api.post('/auth/google', null, {
        headers: {
            Authorization: `Bearer ${googleToken}`
        },
        params: { cdempresa }
    });
    return ret.data;
}

export async function getUsuarioToken(token) {
    const ret = await api.get('/auth/getUsuarioToken', { params: { token }, noLoading: true });
    return ret.data;
}
